/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithTopModule_shoppingWith = {
    readonly mainImage: string | null;
    readonly mobileImage: string | null;
    readonly description: string | null;
    readonly title: string | null;
    readonly subTitle: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithSocial_shoppingWith" | "ShoppingWithMobileDescription_shoppingWith" | "ShoppingWithLinks_shoppingWith">;
    readonly " $refType": "ShoppingWithTopModule_shoppingWith";
};
export type ShoppingWithTopModule_shoppingWith$data = ShoppingWithTopModule_shoppingWith;
export type ShoppingWithTopModule_shoppingWith$key = {
    readonly " $data"?: ShoppingWithTopModule_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithTopModule_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithTopModule_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mobileImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subTitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithSocial_shoppingWith",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithMobileDescription_shoppingWith",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithLinks_shoppingWith",
      "args": null
    }
  ]
};
(node as any).hash = 'c97b0454846163acab71e2a7a0fce794';
export default node;
